var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmailDelivered = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 87,
    viewBox: "0 0 110 87",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#1D1D1D",
    strokeWidth: 3,
    transform: "translate(2) translate(0 16)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 69,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.705 0h80.59C89.445 0 92 2.548 92 5.69v.982c-.002 1.524-.817 2.93-2.14 3.692L48.125 35.176c-1.116.654-2.5.654-3.616 0L2.14 10.492C.81 9.727-.005 8.31 0 6.78V5.691C0 2.548 2.554 0 5.705 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2) translate(76)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.733,
    height: 31.733,
    fill: "#99BA14",
    rx: 15.867
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14.33 21.813l-4.309-4.308c-.396-.397-.396-1.04 0-1.436.397-.397 1.04-.397 1.436 0l2.873 2.871 6.654-6.654c.397-.396 1.04-.396 1.436 0 .397.397.397 1.04 0 1.436l-8.09 8.091z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmailDelivered);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/emailDelivered.c77a4311bc1b92cffcc5aafbfb2fccbe.svg";